import React, { useState, useEffect } from 'react';
import { getWindowMode } from 'helpers/app.helper';
import { debounce, isEqual } from 'lodash';
var withResizeScreen = function (WrappedComponent) { return function (props) {
    var _a = useState(getWindowMode()), windowMode = _a[0], setWindowMode = _a[1];
    var updateDimension = debounce(function () {
        if (!isEqual(windowMode, getWindowMode())) {
            setWindowMode(getWindowMode());
        }
    }, 200);
    useEffect(function () {
        window.addEventListener('resize', updateDimension);
        return function () {
            window.removeEventListener('resize', updateDimension);
        };
    }, []);
    return <WrappedComponent {...props} windowMode={windowMode}/>;
}; };
export default withResizeScreen;
